import { useState, useEffect } from "react";
import help from "@manta-scouting/shared-assets/pi-connection-help.json";
import { laptopPlatform } from "../lib/laptopPlatform";

/** The OS choices shown, in this order; the laptop's own is picked first. */
export const PLATFORMS = ["mac", "windows", "chromeos", "linux"];

/**
 * What to check when the Pi can't be reached, for this laptop's OS (the steps are shared
 * with Neptune: packages/shared-assets/pi-connection-help.json). Opened from the status
 * chip. Closes itself once the Pi answers, so the scout sees the fix worked.
 */
function PiHelp({ reachable, blocked, onClose }) {
    const detected = laptopPlatform();
    const [platform, setPlatform] = useState(PLATFORMS.includes(detected) ? detected : "mac");

    useEffect(() => {
        if (!reachable) return undefined;
        const timer = setTimeout(onClose, 1500);
        return () => clearTimeout(timer);
    }, [reachable, onClose]);

    const steps = [...(blocked ? [help.blocked] : []), ...help.platforms[platform].steps];

    return (
        <div
            role="dialog"
            aria-label="Can't reach the Pi"
            onClick={onClose}
            style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{ background: "#1b1f27", color: "#e5e7eb", borderRadius: "0.6rem", padding: "1rem 1.2rem", maxWidth: "34rem", width: "100%", maxHeight: "85vh", overflowY: "auto", fontSize: "0.9rem", lineHeight: 1.4, textAlign: "left" }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.5rem" }}>
                    <strong style={{ fontSize: "1.05rem" }}>{reachable ? "Connected to the Pi" : "Can't reach the Pi"}</strong>
                    <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", color: "inherit", fontSize: "1.3rem", cursor: "pointer" }}>×</button>
                </div>
                <p style={{ margin: "0.4rem 0", color: reachable ? "#22c55e" : "#fca5a5" }}>
                    {reachable ? "It's working - closing." : "Still looking for it every second while you check:"}
                </p>
                <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap", margin: "0.5rem 0" }}>
                    {PLATFORMS.map((p) => (
                        <button
                            key={p}
                            onClick={() => setPlatform(p)}
                            aria-pressed={p === platform}
                            style={{ padding: "0.25rem 0.6rem", borderRadius: "0.35rem", cursor: "pointer", border: "1px solid #617b94", background: p === platform ? "#617b94" : "transparent", color: "inherit" }}
                        >
                            {help.platforms[p].name}{p === detected ? " (this laptop)" : ""}
                        </button>
                    ))}
                </div>
                <ol style={{ paddingLeft: "1.2rem", margin: "0.5rem 0" }}>
                    {steps.map((step) => (
                        <li key={step.title} style={{ marginBottom: "0.6rem" }}>
                            <strong>{step.title}</strong>
                            <div>{step.detail}</div>
                        </li>
                    ))}
                </ol>
                <p style={{ margin: 0, color: "#9ca3af" }}>{help.always}</p>
            </div>
        </div>
    );
}

export default PiHelp;
